import React, {Component} from 'react';
import {Container, Row, Col, Card, CardHeader, CardBody, CardFooter, Alert} from 'reactstrap';
import {Form, Input, Button} from 'muicss/react';
import Cookies from 'universal-cookie';
import axios from 'axios';
import Logo from './../../assets/DAPSwhitelogo.png';

const cookies = new Cookies();
const moment = require('moment');
const qs = require('qs');
const prebase = window.location.protocol + '//' + window.location.host
const base = (prebase.indexOf('3000') > -1) ? prebase.replace('3000', '8080') : prebase;

export default class PatientUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pid: props.match.params.pid,
            username: '',
            email: '',
            password: '',
            passwordTwo: '',
            valid: false,
            match: false,
            passwordComplexity: 0,
            alertShow: false,
            alertMessage: '',
            color: 'danger',
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let passwordComplexity = this.state.passwordComplexity;
        if (name === 'password') {
            if (value.length < 8) {
                passwordComplexity = 0;
            } else {
                const hasUpperCase = /[A-Z]/.test(value);
                const hasLowerCase = /[a-z]/.test(value);
                const hasNumbers = /\d/.test(value);
                const hasNonAlphas = /\W/.test(value);
                passwordComplexity = 1 + hasUpperCase + hasLowerCase + hasNumbers + hasNonAlphas;
            }
        }
        this.setState({
            [name]: value,
            passwordComplexity: passwordComplexity
        }, this.checkPassword);
    }

    checkPassword() {
        const match = (this.state.password !== ''  && this.state.passwordTwo !== '' && this.state.password === this.state.passwordTwo);
        this.setState({
            match: match,
        })
    }

    handleSubmit(event) {
        event.preventDefault();
        if (!this.state.match || this.state.passwordComplexity < 4) {
            this.setState({ alertShow: true, alertMessage: 'Passwords must match and be more than 8 characters in length, and contain a at a combination of at least three of the following: uppercase letters, lowercase letters, numbers or special characters.' });
        } else {
            let csrfToken = cookies.get('csrftoken');
            let authToken = cookies.get('auth_token')
            let user = {
                csrfmiddlewaretoken: csrfToken,
                pid: this.state.pid,
                username: this.state.username,
                email: this.state.email,
                password: this.state.password,
            }
            axios({
                method: 'post',
                url: `${base}/api/patients/user/`,
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                    'Authorization': `Token ${authToken}`
                },
                withCredentials: true,
                data: user
            }).then(response => {
                console.log(response);
                this.props.history.push(`/admin/patients/${this.state.pid}/footpoints`)
            }).catch(error => {
                console.log(error);
            })
        }
    }

    render() {
        return (
            <Container>
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <CardHeader>
                            <legend>Enroll Patient</legend>
                        </CardHeader>
                        <CardBody>
                            <Alert className="m-2" color={this.state.color} isOpen={this.state.alertShow} toggle={() => { this.setState({ alertShow: false }) }}>
                                {this.state.alertMessage}
                            </Alert>
                            <fieldset>
                                <label htmlFor="patient-enroll-username">User Name</label>
                                <Input type="text" name="username" id="patient-enroll-username" value={this.state.username} onChange={this.handleInputChange} required={true} />
                                <label htmlFor="patient-enroll-email">Email</label>
                                <Input type="email" name="email" id="patient-enroll-email" value={this.state.email} onChange={this.handleInputChange} required={true} />
                                <span className="float-right fa fa-check-circle text-danger" hidden={this.state.valid}>'Passwords must be more than 8 characters in length, and contain a at a combination of at least three of the following: uppercase letters, lowercase letters, numbers or special characters.'</span>
                                <label htmlFor="patient-enroll-password">Password</label>
                                <Input type="password" name="password" id="patient-enroll-password" value={this.state.password} onChange={this.handleInputChange} required={true} />
                                <p>Complexity requirements: All passwords must be at least 8 characters, and contain a at a combination of at least three of the following: uppercase letters, lowercase letters, numbers or special characters.</p>
                                <p>Complexity: <span style={{color: this.state.passwordComplexity < 2 ? 'red' : (this.state.passwordComplexity < 4 ? 'orange' : 'green')}}>{this.state.passwordComplexity < 2 ? 'Poor' : (this.state.passwordComplexity < 4 ? 'Moderate' : 'Strong')}</span></p>
                                <label htmlFor="patient-enroll-password-two">Confirm Password</label>
                                <span className="float-right fa fa-check-circle text-danger" hidden={this.state.match}>Passwords must match</span>
                                <Input type="password" name="passwordTwo" id="patient-enroll-password-two" value={this.state.passwordTwo} onChange={this.handleInputChange} required={true} />
                            </fieldset>
                        </CardBody>
                        <CardFooter>
                            <Button variant="raised" className="bg-success" color="primary" type="submit" disabled={(this.state.match === false || this.state.passwordComplexity < 4)}>Submit</Button>
                        </CardFooter>
                    </Form>
                </Card>
            </Container>
        )
    }
}